import { render, staticRenderFns } from "./accessErrorPage.vue?vue&type=template&id=9796889a&scoped=true"
import script from "./accessErrorPage.vue?vue&type=script&lang=js"
export * from "./accessErrorPage.vue?vue&type=script&lang=js"
import style0 from "./accessErrorPage.vue?vue&type=style&index=0&id=9796889a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9796889a",
  null
  
)

export default component.exports